class TableFootnotes {
  constructor() {
    const footnotes = document.querySelectorAll('p.ns-style-footnote');
    footnotes.forEach(footnote => {
      this.nestFootnote(footnote);
    })
  }

  nestFootnote(footnote) {
    const wrapper = document.createElement('span');
    wrapper.classList.add('ns-style-footnote-wrapper')
    const footnoteKey = footnote.querySelector('.ns-footnote-key');
    const innerSpans = Array.prototype.slice.call(footnote.querySelectorAll('span:not(.ns-footnote-key)'));

    innerSpans.forEach(innerSpan => {
      wrapper.append(innerSpan)
    });

    footnote.append(wrapper);
  }
}

export default TableFootnotes;